import styled from "styled-components";

export const StyledFlex = styled.div`
	display: flex;
	flex-direction: ${({ direction }) => direction || "row"};
	align-items: ${({ align }) => align || "stretch"};
	justify-content: ${({ justify }) => justify || "stretch"};
	flex-wrap: ${({ wrap }) => wrap || "nowrap"};

	margin: ${({ margin }) => margin || "0"};

	/* --------------------------------- адаптив -------------------------------- */
	@media (max-width: 420px) {
		flex-direction: ${({ mobileDirection }) => mobileDirection || "row"};
		align-items: ${({ mobileAlign }) => mobileAlign || "stretch"};
		justify-content: ${({ mobileJustify }) => mobileJustify || "stretch"};
		flex-wrap: ${({ mobileWrap }) => mobileWrap || "nowrap"};

		margin: ${({ mobileMargin }) => mobileMargin || "0"};
	}
`;
